var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4498 6.1002C6.94097 6.1002 8.14981 4.89136 8.14981 3.4002C8.14981 1.90903 6.94097 0.700195 5.4498 0.700195C3.95864 0.700195 2.7498 1.90903 2.7498 3.4002C2.7498 4.89136 3.95864 6.1002 5.4498 6.1002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4498 7.9002C8.43214 7.9002 10.8498 10.3179 10.8498 13.3002H0.0498047C0.0498047 10.3179 2.46747 7.9002 5.4498 7.9002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6498 4.3002C12.6498 3.80314 12.2469 3.4002 11.7498 3.4002C11.2527 3.4002 10.8498 3.80314 10.8498 4.3002V5.2002H9.94981C9.45275 5.20019 9.0498 5.60314 9.0498 6.1002C9.0498 6.59725 9.45275 7.0002 9.94981 7.0002H10.8498V7.9002C10.8498 8.39725 11.2527 8.8002 11.7498 8.8002C12.2469 8.8002 12.6498 8.39725 12.6498 7.9002V7.0002H13.5498C14.0469 7.0002 14.4498 6.59725 14.4498 6.1002C14.4498 5.60314 14.0469 5.2002 13.5498 5.2002H12.6498V4.3002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.06c67c07eb0165ec0b92fa80cd0c5909.svg";
export { ForwardRef as ReactComponent };